import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Grid (section fronts)",
    description:
        "Place these at or near the top of section front page, do not use on homepage. Will add rows to handle more content.",
    links: [
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.pknmz7l9ibix",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/kk4Xyq1Q1FtjeLmbfkWLXX/Section-Fronts?node-id=1086-48820&m=dev&focus-id=1086-48812",
        },
    ],
};
